import {RefObject, useEffect, useState} from 'react';

export type LayoutType = 'sideBySide' | 'stacked';

const useLayout = (ref: RefObject<HTMLElement>): LayoutType | undefined => {
    const [layout, setLayout] = useState<LayoutType | undefined>(undefined);

    useEffect(() => {
        if (ref.current) {
            setLayout(
                ref.current.parentElement?.classList.contains('side-by-side')
                    ? 'sideBySide'
                    : 'stacked',
            );
        }
    }, [ref]);

    return layout;
};

export default useLayout;
